var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4688 29.6875L23.4375 27.3438V17.5435M42.1875 25C42.1875 14.6447 33.7928 6.25 23.4375 6.25C13.0822 6.25 4.6875 14.6447 4.6875 25C4.6875 35.3553 13.0822 43.75 23.4375 43.75C30.3776 43.75 36.4371 39.9794 39.6791 34.375M37.0439 22.9424L41.7314 27.6299L46.4189 22.9424",
    stroke: "#007AFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockForward);
export default __webpack_public_path__ + "static/media/clock-forward.e02d4197aaba2a10c17eecd4ac322485.svg";
export { ForwardRef as ReactComponent };